export const setValuesToHostOnboardingFields = (form, onboardingDetails) => {
    form.setFieldsValue({
        id: onboardingDetails.id,
        createdDate: onboardingDetails.createdDate,
        createdUser: onboardingDetails.createdUser,
        company: onboardingDetails.company,
        contact: onboardingDetails.contact,
        commission: onboardingDetails.commission,
        bank: onboardingDetails.bank,
        hostAgreed: onboardingDetails.hostAgreed
    })
}